module.exports = __webpack_public_path__ + "img/footer-logo-1EdTech.ae93087c.png";